import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/blog/components/AiSummaryBar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/common/components/BackgroundVideo.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/common/components/FAQCollapse.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/SectionWrapper.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/SectionFAQ.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/blog/components/AuthorCard.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/blog/components/BlogToc.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/blog/components/KeyTakeaways.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/blog/[slug]/page.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/image-component.js");
